import { render, staticRenderFns } from "./BomView.vue?vue&type=template&id=57c870ae&"
import script from "./BomView.vue?vue&type=script&lang=js&"
export * from "./BomView.vue?vue&type=script&lang=js&"
import style0 from "./BomView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports